var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":'Site secrets'}},[_c('site-secrets',{attrs:{"site-id":_vm.siteId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }